import React from "react";
import PROJECTS from "static/projects";
import "./Home.scss";
import Project from "components/Project/Project";

export default function Home(props) {
  return (
    <div className="home">
      <h1 className="introduction">
        Product designer & fun guy,
        <span className="introduction__break">based in Lagos, Nigeria.</span>
      </h1>
      <p className="job-role">
        Currently working as a Designer at{" "}
        <span className="job-role__color">MAX.NG</span>
      </p>

      <h1 className="selected-works">SELECTED WORKS</h1>

      <div className="projects-container">
        {PROJECTS.map((data, key) => (
          <Project key={key} data={data} />
        ))}
      </div>
    </div>
  );
}
